import axios from 'axios';
import { ApiConfig } from '../constants/apiConfig';
import { studentHeaders } from './apiClient';

// Fungsi Login
export const login = async (nisn, password) => {
  const url = `${ApiConfig.baseUrl}/login`;

  try {
    const response = await axios.post(
      url,
      new URLSearchParams({ nisn, password }),
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );

    const responseData = response.data;

    if (response.status === 200 && responseData.success === true && responseData.token) {
      // Simpan ke localStorage
      localStorage.setItem('auth_token', responseData.token);
      localStorage.setItem('auth_token_scope', ApiConfig.tokenScope);
      localStorage.setItem('auth_token_expires_at', responseData.token_expires_at || '');
      localStorage.setItem('user_id', parseInt(responseData.user_id) || 0);
      localStorage.setItem('nama', responseData.nama || '');
      localStorage.setItem('kelas', responseData.kelas || '');
      localStorage.setItem('jurusan', responseData.jurusan || '');
      localStorage.setItem(
        'guru_pembimbing_id',
        parseInt(responseData.guru_pembimbing_id) || 0
      );
      localStorage.setItem('guru_pembimbing', responseData.guru_pembimbing || '');
      localStorage.setItem(
        'tempat_pkl_id',
        parseInt(responseData.tempat_pkl_id) || 0
      );
      localStorage.setItem('tempat_pkl', responseData.tempat_pkl || '');

      return { success: true, message: 'Login berhasil' };
    } else {
      return {
        success: false,
        message: responseData.message || 'Login gagal. Periksa NISN dan Password.',
      };
    }
  } catch (error) {
    const errMessage =
      error.response?.data?.message || 'Login gagal. Periksa NISN dan Password.';

    return {
      success: false,
      message: errMessage,
    };
  }
};

// Fungsi Reset Password
export const resetPassword = async (id, newPassword, confirmPassword) => {
  const url = `${ApiConfig.baseUrl}/resetPassword`;

  try {
    const response = await axios.post(
      url,
      new URLSearchParams({
        id,
        new_password: newPassword,
        new_password_confirmation: confirmPassword,
      }),
      {
        headers: studentHeaders({
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
      }
    );

    return {
      success: true,
      message: response.data.message,
    };
  } catch (error) {
    const res = error.response;
    let message = 'Terjadi kesalahan saat mereset kata sandi.';

    if (res?.data?.message) {
      message =
        typeof res.data.message === 'string'
          ? res.data.message
          : Object.values(res.data.message).join(' ');
    }

    return {
      success: false,
      message,
    };
  }
};

export const logout = async () => {
  try {
    await axios.post(`${ApiConfig.baseUrl}/logout`, null, {
      headers: studentHeaders({ Accept: 'application/json' }),
    });
  } catch (_) {
    // Logout lokal tetap dilakukan jika jaringan sedang tidak tersedia.
  } finally {
    localStorage.clear();
  }
};
